var map = {
	"./alfa-cell.png": "4fa6",
	"./alshrouq.png": "1e01",
	"./beep.png": "d8f6",
	"./bravo.png": "559b",
	"./careem.png": "4919",
	"./checkout.png": "c6cb",
	"./cmi.png": "2ddf",
	"./dummy.png": "a797",
	"./facebook.png": "8a28",
	"./fcm.png": "508a",
	"./foodics-f5.png": "8d15",
	"./foodics-f51.png": "f70f",
	"./foodics-online.png": "7737",
	"./foodics.png": "2996",
	"./hamburgini.png": "85a0",
	"./happyfox.png": "9240",
	"./hexnode.png": "d95b",
	"./hyperpay.png": "e8da",
	"./infobip.png": "b113",
	"./jawalb.png": "c5a0",
	"./masterpass.png": "5530",
	"./mcx.png": "7419",
	"./mobily.png": "2e0f",
	"./mukafaat.png": "d58b",
	"./ocost.png": "6f99",
	"./payfort.png": "7f67",
	"./payfort1.png": "c167",
	"./reci.pt.png": "bba3",
	"./samba.png": "2b1c",
	"./sdm.png": "f0c8",
	"./smart-sms.png": "51da",
	"./sms4ksa.png": "0e85",
	"./solo-sms.png": "0fd6",
	"./solo-sms1.png": "2724",
	"./solo.png": "45d7",
	"./solo1.png": "2a5f",
	"./tam.png": "9e97",
	"./tap.png": "ae95",
	"./twitter.png": "6f72",
	"./unifonic.png": "33c8",
	"./victory-link.png": "fabc",
	"./wedeliver.png": "41b4",
	"./yallow.png": "4fca",
	"./yamamah.png": "eca9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3c50";